import { Stack } from "@mui/material";
import CustomPaper from "../../../components/ui/CutomPaper";
import BadgeDirection from "../../../components/ui/BadgeDirection";
import { formatCurrency, printFloatValue } from "../../../utils/utils";
import formatNumber from "../../../utils/formatNumber";
import DottedTextField from "../../../_components/DottedTextField";
import Text from "../../../_components/Text";
import { FC } from "react";

interface PaperPositionProps {
  valuePosition: number;
  avgPosition?: number;
  base: string;
  quote: string;
  unrealizedPnl: number;
  fees?: number;
  realizedProfit?: number;
}

const PaperPosition: FC<PaperPositionProps> = ({
  valuePosition,
  avgPosition,
  base,
  quote,
  unrealizedPnl,
  realizedProfit,
  fees,
}) => {
  return (
    <CustomPaper fullWidth>
      <Stack direction="column" gap="8px">
        {fees && (
          <DottedTextField
            placeholder={"Total fees"}
            value={formatCurrency(formatNumber(fees), quote)}
          />
        )}

        {realizedProfit && (
          <DottedTextField
            placeholder={"Realized profit "}
            value={formatCurrency(formatNumber(realizedProfit), quote)}
          />
        )}

        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <DottedTextField placeholder={"Current position"} value={""}>
            {valuePosition === 0 && <></>}
            {valuePosition > 0 && <BadgeDirection gridDirection={"Long"} />}
            {valuePosition < 0 && <BadgeDirection gridDirection={"Short"} />}
          </DottedTextField>

          <Text whiteSpace="nowrap" variant="regular">
            {valuePosition < 0
              ? printFloatValue(valuePosition * -1)
              : printFloatValue(valuePosition)}{" "}
            {base}
          </Text>
        </Stack>

        {avgPosition ? (
          <DottedTextField
            placeholder={"Entry price"}
            value={formatCurrency(formatNumber(avgPosition <= 0 ? 0 : avgPosition), "USDT")}
          />
        ) : null}

        <DottedTextField
          placeholder={"Unrealized PnL"}
          value={formatCurrency(formatNumber(unrealizedPnl), quote)}
        />
      </Stack>
    </CustomPaper>
  );
};

export default PaperPosition;
